<template>
  <section class="bg-h-primary-50 py-10">
    <div class="container mx-auto">
      <GridLayout :list="setlist()" :banner="banner" @onScroll="scrollMeTo">
        <template #content>
          <Loader v-if="loader" :loader="loader" />

          <div v-show="!loader" class="flex flex-col gap-5">
            <div :ref="enumLinks.general">
              <General />
            </div>
            <!-- <div :ref="enumLinks.engage">
              <Engage />
            </div> -->
            <div :ref="enumLinks.objectives">
              <Objectives />
            </div>
            <div :ref="enumLinks.quiz">
              <Quiz />
            </div>
            <div :ref="enumLinks.students">
              <Students />
            </div>
            <!-- <div :ref="enumLinks.leanDash">
              <LeanDash />
            </div> -->
            <div v-if="isAdaptive" :ref="enumLinks.attentionLogs">
              <AttentionLogs />
            </div>
          </div>
        </template>
      </GridLayout>
    </div>
  </section>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent } from "vue";

const GridLayout = defineAsyncComponent(() => import("../Grid/grid.vue"));

const General = defineAsyncComponent(
  () => import("../Course/General/general.vue")
);
const Objectives = defineAsyncComponent(
  () => import("../Course/Objectives/objectives.vue")
);
const Quiz = defineAsyncComponent(() => import("../Course/Quiz/quiz.vue"));
const Students = defineAsyncComponent(
  () => import("../Course/Students/students.vue")
);
const AttentionLogs = defineAsyncComponent(
  () => import("../Course/AttentionLogs/attentionLogs.vue")
);
const Engage = defineAsyncComponent(
  () => import("../Course/Engage/general.vue")
);
const LeanDash = defineAsyncComponent(
  () => import("@/views/Stats/Course/Lean/dashboard.vue")
);
enum Links {
  general = "general",
  objectives = "objectives",
  quiz = "quiz",
  students = "students",
  attentionLogs = "attentionLogs",
  engage = "engage",
  leanDash = "leanDash",
}

export default defineComponent({
  name: "courseStats",
  components: {
    GridLayout,
    General,
    Objectives,
    Quiz,
    Students,
    AttentionLogs,
    Engage,
    LeanDash,
  },
  computed: {
    enumLinks(): typeof Links {
      return Links;
    },
    isAdaptive(): boolean {
      return JSON.parse(localStorage.getItem("isAdaptiveStats") as string);
    },
  },
  data() {
    return {
      list: {
        title: (this.$route.params.courseName as string)?.replaceAll("-", " "),
        links: [
          {
            name: this.$t("stats.course.sidebar.general"),
            linkId: Links.general,
          },
          // {
          //   name: this.$t("stats.course.sidebar.engage"),
          //   linkId: Links.engage,
          // },
          {
            name: this.$t("stats.course.sidebar.objectives"),
            linkId: Links.objectives,
          },
          {
            name: this.$t("stats.course.sidebar.quiz"),
            linkId: Links.quiz,
          },
          {
            name: this.$t("stats.course.sidebar.students"),
            linkId: Links.students,
          },
          // {
          //   name: this.$t("stats.course.sidebar.leanDash"),
          //   linkId: Links.leanDash,
          // },
        ],
      } as { title: string; links: { name: string; linkId: string }[] },
      banner: {
        icon: require("@/assets/images/stats/course-icon.svg"),
        background: require("@/assets/images/stats/course.svg"),
        title: "Curso",
      },
      loader: true as boolean,
    };
  },
  mounted() {
    setTimeout(() => (this.loader = false), 1500);
    localStorage.removeItem("stdClassroomId");
    localStorage.removeItem("stdClassroomName");
    localStorage.removeItem("objClassroomId");
    localStorage.removeItem("objClassroomName");
  },
  methods: {
    scrollMeTo(refName: any): void {
      var element: HTMLElement | any = this.$refs[refName];
      var top = element?.offsetTop;
      if (refName === Links.general) window.scrollTo(0, 0);
      else window.scrollTo(0, top);
    },
    setlist(): { title: string; links: { name: string; linkId: string }[] } {
      if (this.isAdaptive) {
        this.list.links.push({
          name: this.$t("stats.course.sidebar.attentionLogs"),
          linkId: Links.attentionLogs,
        });
        return this.list;
      } else return this.list;
    },
  },
});
</script>
